@if (config()?.isButtonClose) {
  <div class="row banner-generic__container-button-close-container">
    <div class="col-12">
      <plyca-ui-button-generic
        [config]="{ buttonClass: 'btn banner-generic__container-button-close-container--overwrite rounded-circle btn-xs' + (config()?.classButtonClose ?? ''), type: 'button' }"
        (clickEvent)="handleClick($event)"
      >
        <i [class]="config()?.iconCloseClass" aria-hidden="true"></i>
      </plyca-ui-button-generic>
    </div>
  </div>
}
<div [class]="'widget style1 ' + config()?.background">
  <div class="row">
    <div class="col-4">
      <i [class]="config()?.iconMain"></i>
    </div>
    <div class="col-8 text-right mb-2">
      <ng-content />
    </div>
  </div>
</div>
